import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { FreeBoostsStep } from "./AbilityBoostWizardPf2e";

// PF2e grants 4 more free ability boosts at 5th, 10th, 15th, and 20th level — this reuses the same
// free-boost-assignment step from character creation, just without the level-1 ancestry/bg/class
// steps (and with no 18 cap, since that only applies at first level).
export default function LevelUpBoostModal({ open, onOpenChange, milestone, abilities, onComplete }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#322216] border-white/10 text-[#f1e0c5] max-w-md" data-testid="level-up-boost-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Level {milestone} — Ability Boosts!</DialogTitle>
          <DialogDescription>You've reached level {milestone} — assign your 4 free ability boosts.</DialogDescription>
        </DialogHeader>
        {open && (
          <FreeBoostsStep abilities={abilities} count={4} onDone={(next, picked) => onComplete(next, picked.map((a) => ({ source: `level_${milestone}`, ability: a, amount: 2 })))} />
        )}
      </DialogContent>
    </Dialog>
  );
}
